export type Module = {
  number: string
  title: string
  description: string
}

export type StackItem = {
  label: string
  detail: string
  value: number
  isBonus: boolean
}

export type Faq = {
  question: string
  answer: string
}

export const failures: string[] = [
  'No Pacing Strategy — they blow up after the second kilometer.',
  'Weak Engines — strong in the gym, but they die during the station-to-run transitions.',
  'Technical Gaps — 30 to 60 seconds lost on every single station, purely for lack of a tactical approach.',
]

export const modules: Module[] = [
  {
    number: '01',
    title: 'The Physiology of HYROX',
    description:
      'Understand the specific energy systems needed to sustain pace under extreme muscular fatigue.',
  },
  {
    number: '02',
    title: 'Competitive Programming',
    description:
      'How to structure blocks — Base, Build, Peak — so your athletes arrive at the start line in their best shape ever.',
  },
  {
    number: '03',
    title: 'The 8 Stations Masterclass',
    description:
      'Technical breakdowns of every station to shave minutes off the clock.',
  },
  {
    number: '04',
    title: 'Engine Development',
    description: 'The science of building real hybrid work capacity.',
  },
  {
    number: '05',
    title: 'The Transition Game',
    description:
      'Mastering the in-between moments where races are actually won or lost.',
  },
  {
    number: '06',
    title: 'Business & Positioning',
    description:
      'How to market yourself as an elite HYROX specialist — and charge what you are worth.',
  },
]

export const stack: StackItem[] = [
  {
    label: 'The HYROX Coach Blueprint',
    detail: 'The main guide — the complete programming system.',
    value: 197,
    isBonus: false,
  },
  {
    label: 'HYROX Programming Template',
    detail: 'Plug & play blocks you can hand to an athlete today.',
    value: 97,
    isBonus: true,
  },
  {
    label: 'HYROX Engine',
    detail: 'The endurance builder for hybrid work capacity.',
    value: 97,
    isBonus: true,
  },
  {
    label: 'The 8 Stations Technical Breakdown',
    detail: 'Station-by-station tactics and cueing.',
    value: 67,
    isBonus: true,
  },
  {
    label: 'Elite Transitions Manual',
    detail: 'The seconds nobody trains for.',
    value: 47,
    isBonus: true,
  },
  {
    label: 'HYROX Race Strategy Game Plan',
    detail: 'Race-day pacing and decision framework.',
    value: 47,
    isBonus: true,
  },
]

export const totalValue = stack.reduce((sum, item) => sum + item.value, 0)

export const faqs: Faq[] = [
  {
    question: 'Is this for athletes or coaches?',
    answer:
      'This is built specifically for coaches. An athlete can certainly learn from it, but the language and structure are designed for professionals who manage other people’s training.',
  },
  {
    question: 'Does it work for beginner athletes?',
    answer:
      'Yes. The programming principles scale from a first-timer all the way to a pro-level athlete.',
  },
  {
    question: 'Is this a physical book?',
    answer:
      'No — it is a digital product (PDF). You get immediate access to all materials via email, so you can start improving your coaching today.',
  },
  {
    question: 'How do I pay?',
    answer:
      'We accept all major credit cards and secure payment methods (Stripe, PayPal, Mercado Pago).',
  },
]
